export default "__VITE_ASSET__CLNp2mEl__"